export default "__VITE_ASSET__Ba6w2uXi__"